export enum PlaceholderSize {
  Big = 'big',
  Small = 'small',
}
